<template>
  <!-- <div class="content">
    <div class="about">
      <p class="title" :style="{ color: textColor }" id="title">{{ title }}</p>
      <div class="desc" :style="{ color: textColor }">
        <div v-for="(item, index) in desc" :key="index">
          <ul v-if="item.type === 'list'">
            <li v-for="(list, index) in item.text" :key="index">
              {{ index + 1 }}. {{ list }}
            </li>
          </ul>
          <span v-else>{{ item.text }}</span>
        </div>
      </div>
    </div>
  </div> -->
  <div class="main about">
    <div class="mseciton">
      <Header></Header>
      <div class="page1">
        <div class="wrap">
          <h1>About Us<svg t="1739625084529" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6000"><path d="M511.2 950.7c-59.2 0-116.7-11.6-170.8-34.5-52.3-22.1-99.2-53.7-139.5-94s-71.9-87.2-94-139.5C84 628.6 72.4 571.1 72.4 511.9S84 395.2 106.9 341c22.1-52.3 53.7-99.2 94-139.5s87.2-71.9 139.5-94C394.5 84.6 452 73 511.2 73S628 84.6 682.1 107.5c52.3 22.1 99.2 53.7 139.5 94s71.9 87.2 94 139.5c22.9 54.1 34.5 111.6 34.5 170.8s-11.6 116.7-34.5 170.8c-22.1 52.3-53.7 99.2-94 139.5s-87.2 71.9-139.5 94c-54.1 23-111.6 34.6-170.9 34.6z m0-816.6c-100.9 0-195.8 39.3-267.1 110.6-71.3 71.4-110.6 166.3-110.6 267.2 0 100.9 39.3 195.8 110.6 267.1 71.4 71.4 166.2 110.6 267.1 110.6 100.9 0 195.8-39.3 267.1-110.6S889 612.8 889 511.9c0-100.9-39.3-195.8-110.6-267.1-71.4-71.4-166.2-110.7-267.2-110.7z" fill="#d4237a" p-id="6001"></path><path d="M509.1 667.5c-19.4 0-41.7-5.6-66.3-16.8-18.2-8.2-31.1-16.6-31.6-16.9-9.4-6.1-12.1-18.8-5.9-28.2 6.1-9.4 18.7-12.1 28.2-6 11.9 7.7 48.9 27.6 76.7 27.1 28.7-0.5 67.1-20 79.5-27.5 9.6-5.8 22.1-2.7 28 6.9 5.8 9.6 2.7 22.1-6.9 28-2.2 1.3-54.5 32.5-99.9 33.3-0.6 0.1-1.2 0.1-1.8 0.1zM355.3 483.7s-0.1 0 0 0c-11.3 0-20.4-9.2-20.4-20.4l0.2-69.6c0-11.2 9.1-20.3 20.4-20.3h0.1c11.2 0 20.3 9.2 20.3 20.4l-0.2 69.6c-0.1 11.2-9.2 20.3-20.4 20.3zM606.5 440.1c-6.4 0-12.7-3-16.6-8.6-6.5-9.2-4.3-21.9 4.8-28.4l60.7-43.1c9.2-6.5 21.9-4.3 28.4 4.8 6.5 9.2 4.3 21.9-4.8 28.4l-60.7 43.1c-3.6 2.6-7.7 3.8-11.8 3.8z" fill="#d4237a" p-id="6002"></path><path d="M664 485.4c-4.3 0-8.7-1.4-12.4-4.2l-58.4-45c-8.9-6.9-10.6-19.6-3.7-28.6 6.9-8.9 19.6-10.6 28.6-3.7l58.4 45c8.9 6.9 10.6 19.6 3.7 28.6-4.1 5.1-10.1 7.9-16.2 7.9z" fill="#d4237a" p-id="6003"></path></svg></h1>
          <div class="desc">Wing Chat: AI, Tailored for You</div>
          <div class="desc">Wing Chat APP is an intelligent assistant designed to simplify your work, study, and life. We not only provide efficient tools but also aim to be your emotional support. By engaging in in-depth conversations with AI, you can share your joys and sorrows, making Wing Chat your most trusted friend. Additionally, Wing Chat features a powerful knowledge base that can answer your questions and expand your knowledge boundaries. Whether in work, study, or life, Wing Chat will be your indispensable assistant, helping you effortlessly tackle various challenges.</div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"

export default {
  components: {Header, Footer},
  data() {
    return {
      title: "",
      desc: [],
    };
  },
  computed: {
    textColor: function() {
      return this.$store.state.data.theme.desc_color;
    },
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      const { title, desc } = config.page[1];
      this.title = title;
      this.desc = desc;
    },
  },
};
</script>

<style lang="less" scoped>
.main.about{
  .mseciton{
    background-image: none;
    height: auto;
    min-height: auto;
    background-color: #000;
    padding: 0;
    background-color: transparent;
    ::v-deep{
      header{
        padding-top: 0;
        border-bottom: 1px solid #eee;
      }
    }
  }
  .page1{
    min-height: calc(100vh - 122px);
    color: #444;
    .wrap{
      padding: 40px 0;
      max-width: 1100px;
      text-align: center;
      h1{
        margin-top: 0;
        text-transform: capitalize;
        svg{
          width: 28px;
          margin-left: 6px;
          position: relative;
          top: 2px;
        }
      }
      .desc{
        line-height: 30px;
        text-align: left;
        &:last-child{
          margin-top: 20px;
        }
      }
    }
  }
}

.content {
  padding: 10px 0;
  flex: 1;
  background-image: url("~@/assets/images/about.png");
  background-size: cover;
  width: 100%;
  display: flex;
  align-items: center;
  .about {
    // max-width: 960px;
    transform: translateX(36%);
    width: 54%;
    .title {
      font-size: 33px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 46px;
    }
    .desc {
      width: 80%;
      line-height: 24px;
      div {
        margin-bottom: 15px;
      }
      ul {
        margin-top: 10px;
      }
      ul li {
        margin-left: 20px;
        font-size: 18px;
      }
    }
  }
}
</style>
